import { type ReactElement } from 'react';
import styles from './palmares-search.module.scss';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconsEnum } from '@utmb/types/icons';
import { getColorStyle } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';
import { useTranslation } from 'next-i18next';

export interface PalmaresSearchProps {
    value: string;
    onChange: (value: string) => void;
}

export function PalmaresSearch({ value, onChange }: PalmaresSearchProps): ReactElement {
    const { t } = useTranslation();
    return (
        <div className={styles['palmares-search']}>
            <span className={styles.icon}>
                <Icon variant={IconsEnum.SEARCH} width={24} height={24} color={getColorStyle(ColorTypesEnum.GREY_TEXT)} />
            </span>
            <input placeholder={t('singleRunner.resultsTable.search')} value={value} onChange={(e) => onChange(e.target.value)} />
        </div>
    );
}
